/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/ban-types */
import { useConfig } from '@revenuewell/logic-config'
import { useOidcWithAdmin } from '@revenuewell/logic-oidc'
import React, { useState } from 'react'
import { createContext, PropsWithChildren } from 'react'
import { ContactService } from '../services/contact/contact-service'
import { Contact, ContactSearchByNumber } from '../services/contact/types'
import { normaliseUSPhoneNumber } from '../utils/phone-utils'

export interface IContactContext {
  getContactsByPhoneNumber(phone: string): Promise<ContactSearchByNumber[]>
  getContactDetailsById(contactId: number): Promise<Contact>
}

export const ContactContext = createContext<IContactContext>(null!)

export function ContactProvider({ children }: PropsWithChildren<{}>) {
  const { config } = useConfig()
  const { oidcService } = useOidcWithAdmin()
  // todo: make a universal caching algorithm (maybe with expiration time?)
  const [cachedContactsByPhone, setCachedContactsByPhone] = useState<Record<string, ContactSearchByNumber[]>>({})
  const [cachedContactsDetails, setCachedContactsDetails] = useState<Record<number, Contact>>({})
  const contactService = new ContactService(config, oidcService)

  const getContactsByPhoneNumber = async (phone: string) => {
    const normalizedPhone = normaliseUSPhoneNumber(phone);

    if(cachedContactsByPhone && cachedContactsByPhone[normalizedPhone])
      return cachedContactsByPhone[normalizedPhone]

    const contacts = await contactService.getContactsByPhoneNumbers(normalizedPhone)
    cachedContactsByPhone[normalizedPhone] = contacts[normalizedPhone]
    setCachedContactsByPhone(cachedContactsByPhone)
    return cachedContactsByPhone[normalizedPhone]
  }

  const getContactDetailsById = async (contactId: number) => {
    if(cachedContactsDetails && cachedContactsDetails[contactId])
      return cachedContactsDetails[contactId]

    const contactDetails = await contactService.getContactDetailsById(contactId)
    cachedContactsDetails[contactId] = contactDetails
    setCachedContactsDetails(cachedContactsDetails)
    return cachedContactsDetails[contactId]
  }

  return (
    <ContactContext.Provider value={{
      getContactsByPhoneNumber,
      getContactDetailsById
    }}>
      {children}
    </ContactContext.Provider>
  )
}
